import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=267017da&scoped=true&"
import script from "./Iframe.vue?vue&type=script&lang=js&"
export * from "./Iframe.vue?vue&type=script&lang=js&"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=267017da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267017da",
  null
  
)

export default component.exports